import { ApolloClient } from '@apollo/client/core';
import { CONSUME_INVITED_SITTER_TOKEN_MUTATION } from '@/graphql/backup_care/mutations';
import { getSharedApolloClient } from '@/lib/apollo_setup';
import { deleteDomainCookie, writeDomainCookie } from '@/lib/domain_cookie';

export function removeInvitedSitterCachedData() {
  deleteDomainCookie('interviewRequestId');
  deleteDomainCookie('invitedSitterToken');
  deleteDomainCookie('invitedSitterId');
}

export async function consumeInvitedSitterToken(
  interviewRequestId,
  invitedSitterToken,
  invitedSitterId,
  apolloClient?: ApolloClient<any>
) {
  const apollo = apolloClient || getSharedApolloClient();

  try {
    const res = await apollo.mutate({
      mutation: CONSUME_INVITED_SITTER_TOKEN_MUTATION,
      variables: { interviewRequestId, invitedSitterToken, invitedSitterId },
    });
    return res.data.success;
  } catch (error: any) {
    console.error('Error in consume invited sitter token mutation:', error);
    throw new Error('Failed to consume invited sitter token');
  }
}

export function cacheInvitedSitterData(interviewRequestId, invitedSitterToken, invitedSitterId) {
  writeDomainCookie('interviewRequestId', interviewRequestId);
  writeDomainCookie('invitedSitterToken', invitedSitterToken);
  writeDomainCookie('invitedSitterId', invitedSitterId);
}
